<template>
	<draggable
		class="table-content__list"
		:class="classId"
		tag="div"
		:list="list"
		:group="{ name: 'table-of-content' }"
		item-key="name"
		ghost-class="under-drag"
		@end="onEnd"
	>
		<template #item="{ element }">
			<div v-if="depth < depthMax" class="table-content__article">
				<div class="table-content__item">
					<span>Node: {{ element.id}}</span>
					<span :class="element.deleted ? 'color--rosy-pink' : ''"> {{ element.title }}</span>
				</div>
				<content-table
					:emit-event="emitEvent"
					:list="element.children"
					:depth="depth + 1"
					:class-id="classId"
					@drag-end="onEnd"
				/>
			</div>
			<div v-else class="table-content__article">
				<div class="table-content__item">
					<span>Node: {{ element.id}}</span>
					<span  :class="element.deleted ? 'color--rosy-pink' : ''" >{{ element.title }}</span>
				</div>
			</div>
		</template>
	</draggable>
</template>
<script>
import draggable from 'vuedraggable'


export default {
	props: {
		list: {
			required: true,
			type: Array
		},
		depth: {
			type: Number,
			default: 0
		},
		depthMax: {
			type: Number,
			default: 3
		},
		emitEvent: {
			type: Boolean,
			default: false
		},
		classId: {
			type: String,
			default: ''
		}
	},
	components: {
		draggable
	},
	name: "content-table",
	setup(props, {emit}){
		function onEnd(event){
			if(props.emitEvent) emit('drag-end', event);
		}
		
		return {
			onEnd
		}
	}
};
</script>
<style>
</style>